import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef } from "react";
import Icon from "../../../base/icons/icon/index.js";
import ErrorTooltip from "../../others/error-tooltip/index.js";
import useInput from "../../../../hooks/forms/useInput/index.js";
import CounterButton from "./components/counter-button/index.js";
import useCounter from "./hooks/useCounter.js";
import * as S from "./styled.js";
export const Counter = /*#__PURE__*/ forwardRef((props, ref)=>{
    const wrapperRef = useRef(null);
    useImperativeHandle(ref, ()=>wrapperRef.current);
    const { error , hasError , disableIncrement =false , className  } = props;
    const { value , increment , decrement , isMinimum , isMaximum  } = useCounter(props);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(S.CounterBox, {
                ref: wrapperRef,
                "data-testid": "Counter",
                className: className,
                children: [
                    /*#__PURE__*/ _jsx(CounterButton, {
                        "data-testid": "CounterDecrement",
                        onClick: decrement,
                        disabled: isMinimum,
                        classMod: "decrement",
                        children: /*#__PURE__*/ _jsx(Icon, {
                            className: "nico-minus"
                        })
                    }),
                    /*#__PURE__*/ _jsx(S.Label, {
                        $hasError: hasError,
                        children: value
                    }),
                    /*#__PURE__*/ _jsx(CounterButton, {
                        "data-testid": "CounterIncrement",
                        onClick: increment,
                        disabled: isMaximum || disableIncrement,
                        classMod: "increment",
                        children: /*#__PURE__*/ _jsx(Icon, {
                            className: "nico-plus"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ErrorTooltip, {
                error: error,
                isVisible: !!hasError,
                referenceElement: wrapperRef.current
            })
        ]
    });
});
Counter.displayName = 'Counter';
export const FormCounter = (props)=>{
    const { isHiddenRequired: _isHiddenRequired , ...rest } = props;
    const { field , error , hasError  } = useInput(props);
    return /*#__PURE__*/ _jsx(Counter, {
        ...rest,
        ...field,
        error: error,
        hasError: hasError
    });
};
export default Counter;

//# sourceMappingURL=index.js.map